<template>
    <head>
        <meta charset="utf-8">
        <meta content="width=device-width, initial-scale=1.0" name="viewport">

        <title>Smart App - Megacad</title>
        <meta content="" name="description">
        <meta content="" name="keywords">
    </head>

    <body>>

        <main id="main" class="main">
            <slot></slot> 
        </main>

    </body>
  </template>
  
  <script>

  export default {
    name: 'GuestLayout',

  };
  </script>
  